import { SectionTitle } from "../../components/SectionTitle";
import { CardContainer } from "../../components/CardLayout";
import { SitesOverviewCard } from "../EnrollmentSection";
import DonutPlot from "@/components/CategoricalPlots/barplot";

export default function DemoEnrollmentSection({ data }: { data: any }) {
  const enrollmentStats = {
    Complete: data.enrollment_stats_complete,
    Active: data.enrollment_stats_active,
    "Early Termination": data.enrollment_stats_early_termination,
  };
  const screeningStats = {
    Success: data.screening_stats_success,
    "In Progress": data.screening_stats_in_progress,
    Failure: data.screening_stats_failure,
  };

  return (
    <div>
      <SectionTitle title="ENROLLMENT" />
      <div className="grid lg:grid-cols-9 sm:grid-cols-2 grid-cols-1  gap-4 ">
        <div className="col-span-9 ">
          <div className="grid lg:grid-cols-10 sm:grid-cols-3 grid-cols-1 gap-4 h-full">
            <div className="lg:col-span-4 sm:col-span-3 col-span-1 h-full">
              <SitesOverviewCard data={data} />
            </div>
            <div className="lg:col-span-3 sm:col-span-3 col-span-1 h-full max-h-[250px]">
              <CardContainer className="h-full max-h-[250px]">
                <DonutPlot
                  fontSize={10}
                  className="missing-data sites-info"
                  text={["Enrollment"]}
                  keepDataOrder={true}
                  data={enrollmentStats}
                  subtext={["All subjects at all sites"]}
                />
              </CardContainer>
            </div>
            <div className="lg:col-span-3 sm:col-span-3 col-span-1 h-full">
              <CardContainer className="h-full max-h-[250px]">
                <DonutPlot
                  fontSize={10}
                  className="missing-data sites-info"
                  text={["Screening"]}
                  subtext={["All subjects at all sites"]}
                  keepDataOrder={true}
                  data={screeningStats}
                />
              </CardContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
